import {
  OrderDirection,
  commonMutationTypes,
} from "../../../../../../../utils/commonQueryTypes";
import { itemLdgrAssociData } from "../../queries/types";

export interface AddItemLdgrAssociByLdgrResult {
  AddItemLdgrAssociByLdgr: boolean;
}

export interface AddItemLdgrAssociByLdgrVar extends commonMutationTypes {
  customer_id: number;
  itemIds: number[];
  ldgrId: number;
}

export interface UpdateItemLdgrAssociByLdgrResult {
  UpdateItemLdgrAssociByLdgrResult: boolean;
}

export interface UpdateItemLdgrAssociByLdgrVar extends commonMutationTypes {
  customer_id: number;
  itemIds: number[];
  ldgrId: number;
}

export enum AtsStckItemLdgrAssoicOrderField {
  LDGR_STATUS = "LDGR_STATUS",
  LDGR_RATING = "LDGR_RATING",
}

export interface GetStckAssocItemstoSupplierDetailsVar {
  token: string;
  customer_id: number;
  input: itemLdgrAssociData;
  orderBy: {
    direction: OrderDirection;
    field: AtsStckItemLdgrAssoicOrderField;
  };
  name: string;
}

export interface DeleteItemLdgrAssociByLdgrResult {
  DeleteItemLdgrAssociByLdgrResult: boolean;
}

export interface DeleteItemLdgrAssociByLdgrResult {
  DeleteItemLdgrAssociByLdgr: boolean;
}

export interface DeleteItemLdgrAssociByLdgrVar extends commonMutationTypes {
  customer_id: number;
  itemIds: number[];
  ldgrId: number;
}
